import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileItem, GoogleFile } from '../models/Datatype';
import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { environment as env } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GdriveService {

  constructor(private global:GlobalService,private auth:AuthService) { }

  private post(url: string, body: any) {
      return new Promise((resolve, reject) => {
          var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.auth.getCookie('token')}`
          });
          this.global.http.post(env["googleApi"] + url, body, { headers: headers, withCredentials: true }).toPromise()
          .then(result => {
            if (result["result"]) {
              resolve(result["rows"]);
            } else {
              throw new Error(result["message"]);
            }
          })
          .catch(result => {
            this.global.errorHandler(result);
            reject();
          });
      });
  }

  uploadFile(json:GoogleFile[]){
    return new Promise<boolean>((resolve)=>{
      this.post("upload", json).then((res) => {
        resolve(true);
      }).catch((err) => {
        console.log(err);
        resolve(false);
      });
    });
  }

  deleteFile(json: GoogleFile[]){
    return new Promise<boolean>((resolve) => {
      this.post("delete", json).then((res) => {
        resolve(true);
      }).catch((err) => {
        console.log(err);
        resolve(false);
      });
    });
  }

  getListFile(apps,path){
    return new Promise<FileItem[]>((resolve,reject) => {
      let json: GoogleFile = new GoogleFile();
      json.section = apps;
      json.path = path;
      this.post("get-file", json).then((res: FileItem[]) => {
        resolve(res);
      }).catch((err) => {
        this.global.showErrorDialog("File tidak ditemukan");
        resolve([]);
      });
    })
  }

  // createFolder(vkbur,kunnr,id){
  //   return new Promise<boolean>((resolve) => {
  //     let json:GoogleFile = new GoogleFile();
  //     json.section = this.section;
  //     json.path = vkbur+"/"+kunnr+"/"+id;
  //     this.post("create-folder",json).then((res)=>{
  //       resolve(true);
  //     }).catch((err)=>{
  //       console.log(err);
  //       resolve(false);
  //     });
  //   });
  // }

  getBase64File(section:string,id: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      let json: GoogleFile = new GoogleFile();
      json.section = section;
      json.id = id;
      this.post("download", json).then(res => {
        resolve(res[0]);
      }).catch(error => {
        reject(null);
        this.global.showErrorDialog(error);
      });
    });
  }
}
